import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ProductCard from "@/components/ProductCard";
import QuickView from "@/components/QuickView";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";

const FILTERS = ["All", "Hoodies", "Tops", "Bottoms"];

export default function Collections() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");
  const [quickView, setQuickView] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products")
      .then((res) => setProducts(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const visible = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div className="mx-auto max-w-[1700px] px-5 pb-28 pt-36 sm:px-8 lg:px-16 lg:pt-44" data-testid="collections-page">
      <Reveal>
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-ember">Collection 001</p>
        <h1 className="mt-4 font-blackletter text-6xl leading-[1] sm:text-8xl lg:text-9xl">
          Résistance
        </h1>
        <p className="mt-6 max-w-lg font-serif text-xl italic text-zinc-400">
          Six pieces. Heavy fabric, heavier intent.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-14 flex flex-wrap gap-2 border-t border-white/5 pt-8">
        {FILTERS.map((f) => (
          <button
            key={f}
            data-testid={`filter-${f.toLowerCase()}`}
            onClick={() => setFilter(f)}
            className={`border px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] transition-colors duration-300 ${
              filter === f
                ? "border-white bg-white text-ink"
                : "border-white/10 text-zinc-500 hover:border-zinc-400 hover:text-zinc-100"
            }`}
          >
            {f}
          </button>
        ))}
      </Reveal>

      {loading ? (
        <p className="mt-24 font-mono text-xs uppercase tracking-[0.3em] text-zinc-600" data-testid="collections-loading">
          Chargement…
        </p>
      ) : (
        <motion.div layout className="mt-12 grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          <AnimatePresence mode="popLayout">
            {visible.map((p, i) => (
              <motion.div
                layout
                key={p.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.97 }}
                transition={{ duration: 0.5, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              >
                <ProductCard product={p} index={i} onQuickView={setQuickView} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      )}

      <AnimatePresence>
        {quickView && <QuickView product={quickView} onClose={() => setQuickView(null)} />}
      </AnimatePresence>
    </div>
  );
}
